import {
  BottomText,
  ButtonControls,
  CodeContainer,
  Container,
  MiddleContainer,
  NavContainer,
  QRContainer,
  QRContainerBorder,
  Row,
  SplashCentent,
  Tags,
  TopText,
  Wrapper,
} from './QROnly.styled';
import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import CrossIcon from '@assets/svg/match/missing.svg';
import Camera_Icon from '@assets/svg/camera.svg';
import CameraSync_Icon from '@assets/svg/camera_sync.svg';
import Pencil_Icon from '@assets/svg/pencil.svg';
import ArtyIcon from '@assets/svg/Badges/arty.svg';
import moment from 'moment';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import QR from '@components/SQScan/QR';
import CodeInput from './CodeInput';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import CheckIn_Ani from '@lotties/checkin.json';
import CheckOut_Ani from '@lotties/checkout.json';
import Modal from '@components/Buttons/Modal';
import { shallow } from 'zustand/shallow';
import { RowTitle, Content, NoteArea, Tag } from '@components/Note/NewNoteControls/NewNoteControls.styled';
import { Button } from "@components/Note/Note.styled";
import { useAuthentication } from '@providers/AuthProvider';
import { MatchActionType } from '@models/MatchActionType';
import { ModalContainer } from '@components/SQScan/QRScanScreen.styled';


interface IProps {
  
}

const QROnly = (props: IProps) => {
  const {
    systemSettings,
    client,
    settings,
    setSplash,
    splash,
    cameraList,
    currentCam,
    whoIsLoggedIn,
    filterDate
  } = useStore(
    (state) => ({
      systemSettings: state.systemSettings,
      client: state.client,
      settings: state.settings,
      setSplash: state.setSplash,
      splash: state.splash,
      cameraList: state.cameraList,
      currentCam: state.currentCam,
      whoIsLoggedIn: state.whoIsLoggedIn,
      filterDate: state.filterDate
    }),
    shallow,
  );
  const [start, setStart] = useState(false);
  const [QR_CheckError, setQR_CheckError] = useState(false);
  const [writeCode, setWriteCode] = useState(true);
  const [scanState, setScanState] = useState(false);
  const [redirectState, setRedirectState] = useState(false);
  const [timeStamp, setTimeStamp] = useState(null);
  const [timeBlock, setTimeBlock] = useState(null);
  const [late, setLate] = useState(false);
  const [helpText, setHelpText] = useState('');
  const [checkState, setCheckState] = useState(true);
  const [error, setError] = useState(null);
  const [checkinError, setCheckinError] = useState(null);
  const username = useRef(null);
  const i18n = useI18n();
  const delayTimer = useRef(null);
  const cameraDelayTimer = useRef(null);
  const qrRef = useRef(null)
  const splashRef = useRef(null)
  const scanRef = useRef(false)
  const [ showState, setShowState] = useState(0);
  const [noteTags, setNoteTags] = useState([]);
  const [tagsList, setTagsList] = useState<any>([]);
  const { getId, getStudentId } = useAuthentication();
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    GetData();
    SetRegistrationMode();
    setStart(true);
  }, []);

  useEffect(() => {
    HandleHelpText();
  }, [writeCode]);

  useEffect(() => {
    HandleHelpText();
  }, [QR_CheckError]);


  const GetData = async () => {
      let getTags = await db.GetNote_Tags("Late");
      let allTags = await db.getAllNote_Tags();
      setTagsList(settings.DEMO === 'true' || settings.DEMO ? allTags : getTags);
  }

  const handleCameraSwitch = (value) => {

    if ((moment().unix() > delayTimer.current + 2) || delayTimer.current === null) {
      delayTimer.current = moment().unix()
      setWriteCode(value)
    }
  }

  async function checkTimeBlocks () {
    let userName = client.UserName;
    if (settings.DEMO === 'true' || settings.DEMO === true) userName = '48637';
    username.current = userName;
    let timeblocks = await db.Regi_GetCoursesByStudentName(userName, moment(), settings.USEMERIT, settings.USEPAUSE);
    let timeblock = null;

    
    


    for (let i = 0; i < timeblocks.length; i++) {
      //@ts-ignore
      let s = (timeblocks[i].starttime.hours < 10 ? ("0" + timeblocks[i].starttime.hours) : timeblocks[i].starttime.hours) + ":" + (timeblocks[i].starttime.minutes < 10?("0" + timeblocks[i].starttime.minutes):timeblocks[i].starttime.minutes) + ":00";
      let startTime = moment(s, 'HH:mm:ss').utc().add(settings.CURRENTOFFSET, 'minutes');;   
      //@ts-ignore
      let e = (timeblocks[i].endtime.hours < 10 ? ("0" + timeblocks[i].endtime.hours) : timeblocks[i].endtime.hours) + ":" + (timeblocks[i].endtime.minutes < 10?("0" + timeblocks[i].endtime.minutes):timeblocks[i].endtime.minutes) + ":00";      
      let endTime = moment(e, 'HH:mm:ss').utc().add(settings.CURRENTOFFSET, 'minutes');;      
      let now = moment().utc().add(settings.CURRENTOFFSET, 'minutes');
      if(now.isBetween(startTime, endTime, 'minute', '[]'))
      {
        timeblock = timeblocks[i];
        let lookUp = await LookUpTimeblockRegi(timeblock)
        let blockMatch = lookUp?.find(s => s.username?.toLowerCase() === userName.toLowerCase());
        // No row (lookup failed or student not on it) is treated like "not registered yet".
        let tagIds = blockMatch?.tag_ids ?? null;
        if(now.isAfter(startTime) && tagIds === null){
          setShowState(1)
          setScanState(!scanState);
          console.log("late")
        } else if(tagIds != null){
          setShowState(3)
          setScanState(!scanState);
          console.log("allready done")
        } else {
          setShowState(2)
          setScanState(!scanState);
          console.log("there is timeblock but not late yet")
        }
        // console.log(lookUp)
        // console.log(blockMatch, userName)
      }
    }
    
    if(timeblock != null){
      setTimeBlock(timeblock)
    } else {
      setShowState(4)
      setScanState(!scanState);
      console.log("no timeblocks")
    }
    // console.log(timeblocks)
    

  };

  async function LookUpTimeblockRegi(timeblock){

    let resualt = await db.Regi_GetStudentsByTimeBlockId(timeblock.id, "mikkel", 2, filterDate.from, filterDate.to);
    return resualt;
  }

  const SetRegistrationMode = () => {
    let registrationMode = systemSettings.find((t) => t.APP_Setting_ID === 44);
    if (registrationMode.value === 'QR' || registrationMode.value === 'Both' || registrationMode.value === "All") {
      setWriteCode(false);
    } else if (registrationMode.value === 'Text') {
      setWriteCode(true);
    }
  };

  const HandleHelpText = () => {
    if (writeCode) {
      setHelpText(i18n.t('qr-code-text'));
      
      setTimeout(() => {
        setQR_CheckError(false);
      }, 5000);
    } else {
      setHelpText(i18n.t('qr-scan-text'));
      
      setTimeout(() => {
        setQR_CheckError(false);
      }, 5000);
    }
  };

  async function HandleCheckIn(code: string): Promise<boolean> {
    let codeCheck = await CheckCode(code);
    return new Promise(async (resolve, reject) => {
      
      if (codeCheck) {
        await checkTimeBlocks();
        resolve(true)
      } else {
        setQR_CheckError(true);
        resolve(false); 
      }
      
    });
  };

  async function CreateLate () {
    setDisableButton(true)
    let json = [{ reservationId: timeBlock.id }];
    let tagsForMessage = noteTags.map((t) => t.tag_id);
    let tagsToString = tagsForMessage.length > 0 ? tagsForMessage.join(',') : 'empty';
    let studentId = getStudentId();
    let res = await db.createLeaveEvent(
      studentId,
      client.UserName,
      studentId,
      client.UserName,
      `${whoIsLoggedIn.firstname} ${whoIsLoggedIn.lastname}`,
      json,
      "",
      tagsToString === null ? 'empty' : tagsToString,
      3,
      2
    )

    let s = (timeBlock.starttime.hours < 10 ? ("0" + timeBlock.starttime.hours) : timeBlock.starttime.hours) + ":" + (timeBlock.starttime.minutes < 10?("0" + timeBlock.starttime.minutes):timeBlock.starttime.minutes) + ":00";
    let startTime = moment(s, 'HH:mm:ss').utc().add(settings.CURRENTOFFSET, 'minutes');;   
    let now = moment().utc().add(settings.CURRENTOFFSET, 'minutes');
    let lateBy = now.diff(startTime, 'minutes');    
    let adjustableLateBy = systemSettings.find((s) => s.APP_Setting_ID === 49);
    let defaultlateMinutes = systemSettings.find((s) => s.APP_Setting_ID === 47);    

    if(adjustableLateBy.value.toLowerCase() === "false"){
      lateBy = defaultlateMinutes.value;
    }

    if(res && res.length > 0 && (res[0].result >= 0 || res[0].absence_id > 0)){
      console.log("Fejl???")
      tagsForMessage = noteTags.map((t) => i18n.t("tag-" + t.name));
      let donno = tagsForMessage.length > 0 ? tagsForMessage.join(',') : 'empty';
      await db.Regi_MarkStudentStatusByTimeBlockIDAndStudentId(timeBlock.id, studentId, 3, client.UserName, false, Number(lateBy), false, tagsToString, donno, false);
      setShowState(5);
      setTimeout(() => {
        ZeroOutVariables();
      }, 600000)
    }
  }

  const CheckCode = async (code: string) => {
    if (isNaN(+code)) return false;
    let codeCheck = await db.Check_CheckInCode(client && client.client_id ? client.client_id : 3, code);
    return codeCheck[0].validcode;
  };


  function handleCamera() {
    if ((moment().unix() > cameraDelayTimer.current + 2) || cameraDelayTimer.current === null) {
      setSplash(true)
      setTimeout(function () {
        splashRef?.current?.handleClose();
      }, 2000);
      cameraDelayTimer.current = moment().unix()
      qrRef.current.swapCamera()
    }
  }

  const HandleNoteTags = (tag: any, filter?: boolean) => {
    if (!filter) {
      if (!noteTags.some((t) => t.tag_id === tag.tag_id)) {
        let temp = noteTags.concat(tag);
        setNoteTags(temp);
      }
    } else {
      let temp = noteTags.filter((nt) => nt.tag_id !== tag.tag_id);
      setNoteTags(temp);
    }
  };

  const ZeroOutVariables = () => {
    setScanState(false);
    setShowState(0)
    setTimeBlock(null);
  }

  const HandleTimeblockDate = (time) => {
    let fixedTime = (time?.hours < 10 ? ("0" + time?.hours) : time?.hours) + ":" + (time?.minutes < 10?("0" + time?.minutes):time?.minutes);      
    return fixedTime;
  }

  function getComponent() {
    if (showState === 4 && scanState) {
      return (
        <Container>
          <MiddleContainer >
            <Row><p>{i18n.t('qr_only_text1')}</p></Row>
            <div style={{height:"40px"}} />
            <ButtonControls>
              <Button disable={true} onClick={() => ZeroOutVariables()}>{i18n.t('Ok')}</Button>
            </ButtonControls>
          </MiddleContainer>
        </Container>
      );
    } else if (showState === 2 && scanState) {
      return (
        <Container>
          <MiddleContainer >
            <Row><p>{i18n.t('qr_only_text2')} {!timeBlock?.displayname?timeBlock?.displayname:timeBlock?.name} {HandleTimeblockDate(timeBlock?.starttime) + " - " + HandleTimeblockDate(timeBlock?.endtime)}. {i18n.t('qr_only_text3')}</p></Row>
            <div style={{height:"40px"}} />
            <ButtonControls>
              <Button disable={true} onClick={() =>  ZeroOutVariables()}>{i18n.t('Ok')}</Button>
            </ButtonControls>
          </MiddleContainer>
        </Container>
      );
    } else if (showState === 5 && scanState) {
      return (
        <Container>
          <MiddleContainer >
            <Row><p>{i18n.t('qr_only_text4')}</p></Row>
            <div style={{height:"40px"}} />
            <ButtonControls>
              {//<Button disable={true} onClick={() =>  ZeroOutVariables()}>{i18n.t('Ok')}</Button>
              }
            </ButtonControls>
          </MiddleContainer>
        </Container>
      );
    } else if (showState === 3 && scanState) {
      return (
        <Container>
          <MiddleContainer >
            <Row><p>{i18n.t('qr_only_text5')} {!timeBlock?.displayname?timeBlock?.displayname:timeBlock?.name} {HandleTimeblockDate(timeBlock?.starttime) + " - " + HandleTimeblockDate(timeBlock?.endtime)}</p></Row>
            <div style={{height:"40px"}} />
            <ButtonControls>
              <Button disable={true} onClick={() =>  ZeroOutVariables()}>{i18n.t('Ok')}</Button>
            </ButtonControls>
          </MiddleContainer>
        </Container>
      );
    } else if (showState === 1 && scanState){
      return (
        <Container>
          <MiddleContainer>
            <Row><p>{i18n.t('qr_only_text6')} {!timeBlock?.displayname?timeBlock?.displayname:timeBlock?.name} {HandleTimeblockDate(timeBlock?.starttime) + " - " + HandleTimeblockDate(timeBlock?.endtime)}. <br />{i18n.t('qr_only_text7')}</p></Row>
            <Row space={true}>
              <RowTitle>{i18n.t('qr_only_text9')}</RowTitle>
              <Content>
                <Tags>
                  {
                    tagsList.map(t => { if (t.tag_id !== 1) return <Tag key={t.tag_id} display={noteTags.some((nt) => nt.tag_id === t.tag_id)} onClick={() => HandleNoteTags(t)} c={t.html_color === 'FED425'} bgColor={t.html_color}>{i18n.t("tag-" + t.name)}</Tag> })
                  }
                </Tags>
              </Content>
            </Row>
            <Row>
              <RowTitle><span>{i18n.t('qr_only_text10')}</span></RowTitle>
              <Content>
                <NoteArea>
                  <Tags pad={true}>
                    {noteTags.map(t => <Tag key={t.tag_id} onClick={() => HandleNoteTags(t, true)} bgColor={t.html_color} c={t.html_color === 'FED425'} delete={true}>{i18n.t("tag-" + t.name)} <div><CrossIcon /></div></Tag>)}
                  </Tags>
                </NoteArea>
              </Content>
            </Row>
            <ButtonControls>
              <Button disable={noteTags.length > 0 || disableButton} onClick={() => CreateLate()} >{i18n.t('note-save')}</Button>
              <Button disable={true} onClick={() => ZeroOutVariables()}>{i18n.t('note-cancel')}</Button>
            </ButtonControls>
          </MiddleContainer>
        </Container>
      ); 
    } else if (checkinError) {
      return (
        <Container>
          <TopText>
            <span>{i18n.t('qr-error')}</span>
          </TopText>
        </Container>
      );
    } else if (error !== null) {
      if (error === 1) {
        return (
          <Container>
            <TopText>
              <span>{i18n.t('qr-kamera-1')}</span>
            </TopText>
            <CodeContainer>
              <CodeInput reset={QR_CheckError} checkCode={HandleCheckIn} />
            </CodeContainer>
          </Container>
        );
      } else if (error === 2) {
        return (
          <Container>
            <TopText>
              <span>{i18n.t('qr-kamera-2')}</span>
            </TopText>
            <CodeContainer>
              <CodeInput reset={QR_CheckError} checkCode={HandleCheckIn} />
            </CodeContainer>
          </Container>
        );
      } else {
        return (
          <Container>
            <TopText>
              <span>{i18n.t('qr-kamera-3')}</span>
            </TopText>
            <CodeContainer>
              <CodeInput reset={QR_CheckError} checkCode={HandleCheckIn} />
            </CodeContainer>
          </Container>
        );
      }
    } else if (checkinError === null && !timeBlock && !scanState) {
      return (
        <Container>
          <TopText>
            <span>{i18n.t(writeCode?'qr_only_writecode':'qr_only_scancode')}</span>
          </TopText>
          {writeCode || error !== null ? (
            <CodeContainer>
              <CodeInput reset={QR_CheckError} checkCode={HandleCheckIn} />
            </CodeContainer>
          ) : writeCode === false ? (
            <QRContainer>
              <QRContainerBorder />
              <QR GetInformation={HandleCheckIn} ref={qrRef} returnResult={HandleCheckIn} error={setError} />
            </QRContainer>
          ) : (
            ''
          )}
          <BottomText>
            <p>{helpText}</p>
          </BottomText>
        </Container>
      );
    } else {
      return (
        <Container>
          <RainbowLoader />
        </Container>
      );
    }
  };

  const getCameraButtons = () => {
    let btns = []
    let registrationMode = systemSettings?.find((t) => t.APP_Setting_ID === 44);
    
    if (registrationMode.value === "Both" || registrationMode.value === "All") {
      btns.push(writeCode ? <Camera_Icon key={"key_cam"} onClick={() => handleCameraSwitch(false)} /> : <Pencil_Icon key={"key_pencil"} onClick={() => handleCameraSwitch(true)} />)
    }

    if (!writeCode) {
      btns.push(<CameraSync_Icon key={"key_camsync"} onClick={() => handleCamera()} />)
    }

    return btns
  }

   const errorRef = useRef(null);
  
  return (<>
    {splash ? <Modal onClose={setSplash} ref={splashRef} fadeTop={true} Placement={{ height: "auto", width: "100vw", top: "20px", left: "0" }}>
      <SplashCentent>
        <span>Switching to camera {currentCam + 1} / {cameraList.length}</span>
      </SplashCentent>
    </Modal> : null}

    {QR_CheckError ? <Modal onClose={setQR_CheckError} ref={errorRef} backColor={"rgba(0,0,0,0.25)"}>
      <ModalContainer>
        <span>{i18n.t("Fejl")}</span>
        <p>{i18n.t("qr-scan-help")}</p>
      </ModalContainer>
    </Modal> : null}

    <Wrapper start={start}>
      <NavContainer >
        {!scanState ? getCameraButtons() : null}
      </NavContainer>
      {getComponent()}
    </Wrapper>
  </>);
};

export default QROnly;
